// Resource authorship follows current workspace ownership, independently of content credits.
export function resourceOwnerAttribution(resource) {
  const owner = resource?.owner_profile ?? resource?.owner;
  const name = owner?.display_name ?? owner?.name;
  if (typeof name !== "string" || !name.trim()) return null;
  return { name: name.trim(), ...(owner.url ? { url: owner.url } : {}) };
}

export function mediaEntryAttribution(entry) {
  const isResource =
    entry?.workspace_id ||
    entry?.owner_profile ||
    (entry?.owner && typeof entry.owner === "object") ||
    ["room", "scene", "scene_listing"].includes(entry?.type);
  return isResource ? resourceOwnerAttribution(entry) : entry?.attributions?.creator ?? null;
}
